import { ChevronLeft, ExternalLink } from "lucide-react";
import { Card } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/card";
import { useNavigate } from "react-router-dom";

const Licenses = () => {
  const navigate = useNavigate();

  const licenses = [
    {
      name: "React",
      version: "18.3.1",
      license: "MIT License",
      description: "A JavaScript library for building user interfaces.",
    },
    {
      name: "React Router",
      version: "6.30.1",
      license: "MIT License",
      description: "Declarative routing for React applications.",
    },
    {
      name: "Tailwind CSS",
      version: "3.4.17",
      license: "MIT License",
      description: "A utility-first CSS framework for rapid UI development.",
    },
    {
      name: "Radix UI",
      version: "Various",
      license: "MIT License",
      description: "Unstyled, accessible UI component primitives.",
    },
    {
      name: "Lucide React",
      version: "0.462.0",
      license: "ISC License",
      description: "Beautiful & consistent icon toolkit.",
    },
    {
      name: "Recharts",
      version: "2.15.4",
      license: "MIT License",
      description: "A composable charting library built on React components.",
    },
    {
      name: "TanStack Query",
      version: "5.83.0",
      license: "MIT License",
      description: "Powerful asynchronous state management for React.",
    },
    {
      name: "date-fns",
      version: "3.6.0",
      license: "MIT License",
      description: "Modern JavaScript date utility library.",
    },
    {
      name: "Zod",
      version: "3.25.76",
      license: "MIT License",
      description:
        "TypeScript-first schema validation with static type inference.",
    },
    {
      name: "React Hook Form",
      version: "7.61.1",
      license: "MIT License",
      description:
        "Performant, flexible and extensible forms with easy-to-use validation.",
    },
    {
      name: "Sonner",
      version: "1.7.4",
      license: "MIT License",
      description: "An opinionated toast component for React.",
    },
    {
      name: "Embla Carousel",
      version: "8.6.0",
      license: "MIT License",
      description: "A lightweight carousel library with fluid motion.",
    },
  ];

  return (
    <div className="min-h-screen bg-background pb-8">
      <div className="mx-auto max-w-md space-y-4 p-4">
        {/* Header */}
        <div className="flex items-center pt-2">
          <button
            onClick={() => navigate("/profile/about")}
            className="rounded-full p-2 transition-colors hover:bg-muted"
          >
            <ChevronLeft className="h-6 w-6" />
          </button>
          <div className="ml-2">
            <h1 className="text-xl font-bold text-foreground">
              Open Source Licenses
            </h1>
            <p className="text-xs text-muted-foreground">
              Third-party software we use
            </p>
          </div>
        </div>

        {/* Introduction */}
        <Card className="rounded-2xl border-0 p-5 shadow-sm">
          <p className="text-sm leading-relaxed text-muted-foreground">
            Bite Balance is built using open source software. We are grateful to
            the developers and communities who maintain these projects. Below is
            a list of the major libraries and their licenses.
          </p>
        </Card>

        {/* License List */}
        <div className="space-y-2">
          {licenses.map((lib, index) => (
            <Card key={index} className="rounded-2xl border-0 p-4 shadow-sm">
              <div className="flex items-start justify-between gap-2">
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="font-semibold text-foreground">
                      {lib.name}
                    </h3>
                    <span className="text-xs text-muted-foreground">
                      v{lib.version}
                    </span>
                  </div>
                  <p className="mt-0.5 text-xs font-medium text-primary">
                    {lib.license}
                  </p>
                  <p className="mt-1 text-xs text-muted-foreground">
                    {lib.description}
                  </p>
                </div>
                <ExternalLink className="mt-1 h-4 w-4 flex-shrink-0 text-muted-foreground" />
              </div>
            </Card>
          ))}
        </div>

        {/* MIT License Text */}
        <Card className="rounded-2xl border-0 bg-muted/30 p-5 shadow-sm">
          <h3 className="mb-3 font-semibold text-foreground">
            MIT License (Summary)
          </h3>
          <p className="text-xs leading-relaxed text-muted-foreground">
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation
            files, to deal in the Software without restriction, including
            without limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software.
          </p>
        </Card>

        {/* Footer */}
        <p className="text-center text-xs text-muted-foreground">
          © 2025 Bite Balance. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Licenses;
